var Trigger = (function () {

    var $ = require('jquery');
    var self = {};

    self.$toggleTrigger = $('[data-trigger]');
    self.$closeTrigger = $('[data-trigger-close]');
    self.openClassName = '-open';

    self.init = function () {

        self.$toggleTrigger.on('click', function (ev) {
            ev.preventDefault();

            self.toggle($(this).data('trigger'));

        });

        self.$closeTrigger.on('click', function (ev) {
            ev.preventDefault();

            self.close($(this).data('trigger-close'));

        });

    };

    self.toggle = function (target) {

        if (target) {

            App.Globals.$body.toggleClass(target + self.openClassName);

            //  For search we need a focus on the input field
            if (target === 'search') {

                setTimeout(function () {
                    $('.search-wrapper input').focus();
                }, 200);

            }

            if (target === 'menu') {

                App.Globals.$body.find('.menu-solutions-wrapper li.current-menu-item').removeClass('current-menu-item');

            }

        }

    };

    self.close = function (target) {

        if (target) {

            var targets = target.split(',');

            if (targets.length > 0) {

                for (var i = 0; i < targets.length; i++) {

                    App.Globals.$body.removeClass(targets[i] + self.openClassName);

                }

            }

        }

        App.Globals.$body.find('.menu-solutions-wrapper li.current-menu-item').removeClass('current-menu-item');

    };

    return self;

}());

module.exports = Trigger;
